/**
 * Route for `pre-landing-page-support`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { PreLandingPageSupportPage } from "../features/pre-landing-page-support/PreLandingPageSupportPage";

export const preLandingPageSupportRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/pre-landing-page-support",
	component: PreLandingPageSupportPage,
});

export default preLandingPageSupportRoute;
